'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dofImage = require('../dof-image');

var _dofImage2 = _interopRequireDefault(_dofImage);

var _dolphinNativeBridge = require('dolphin-native-bridge');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { DofImage, DofMinibar } from "../../index";
var animation = weex.requireModule('animation'); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: { DofImage: _dofImage2.default },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 600
    },

    title: {
      type: String,
      default: ''
    },

    leftBtnText: {
      type: String,
      default: '取消'
    },
    rightBtnText: {
      type: String,
      default: '确定'
    }
  },
  data: function data() {
    return {
      bottomArc: 0
    };
  },


  watch: {},

  computed: {
    isipx: function isipx() {
      if (this.bottomArc) return true;
      return weex && (weex.config.env.deviceModel === 'iPhone10,3' || weex.config.env.deviceModel === 'iPhone10,6' || // iphoneX
      weex.config.env.deviceModel === 'iPhone11,8' || // iPhone XR
      weex.config.env.deviceModel === 'iPhone11,2' || // iPhone XS
      weex.config.env.deviceModel === 'iPhone11,4' || weex.config.env.deviceModel === 'iPhone11,6') // iPhone XS Max
      ;
    },
    wrapHeight: function wrapHeight() {
      var tmp = '';
      if (this.isipx) {
        tmp = this.height + 34;
      } else {
        tmp = this.height;
      }
      return tmp + 'px';
    }
  },
  methods: {
    // cancel() {
    //   this.show = false;
    //   this.$emit('dofPopupOverlayClicked');
    // },

    open: function open() {
      var _this = this;
      console.log('open');
      var el = this.$refs.boxWrap;
      var translate = 'translate(0px, 0px)';
      _this.animationFn(el, translate, 'cubic-bezier( 1.0, 0.25, 0.1, 0.25)', function () {
        _this.show = true; // overlay show = false
        _this.$emit('dofPopupOverlayClicked');
      });
    },
    cancel: function cancel() {
      var _this = this;
      console.log('cancel');
      var el = this.$refs.boxWrap;
      var translate = 'translate(0px, ' + this.height + 'px)';
      _this.animationFn(el, translate, 'cubic-bezier( 1.0, 0.25, 0.1, 0.25)', function () {
        _this.show = false; // overlay show = false
        _this.$emit('dofPopupOverlayClicked');
      });
    },
    leftBtnClick: function leftBtnClick() {
      this.$emit('leftBtnClick');
    },
    rightBtnClick: function rightBtnClick() {
      this.$emit('rightBtnClick');
    },
    animationFn: function animationFn(el, translate, timing, fn) {
      animation.transition(el, {
        styles: {
          transform: translate,
          transformOrigin: 'center center'
        },
        duration: 300, // ms
        timingFunction: timing,
        delay: 0 // ms
      }, function () {
        fn && fn();
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    var _this2 = this;

    _dolphinNativeBridge.Bridge.getAllBarHeight().then(function (res) {
      _this2.bottomArc = res.bottomArc || 0;
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-confirm-box/index.vue
// module id = 327
// module chunks = 0 1